export default function (value: number | Record<string, number>): number | string {
  if (!value) {
    return 0;
  }
  if (typeof value == 'object') {
    return JSON.stringify(value, null, '\n');
  }
  return Math.round(value);
}
